import { List, ListItemButton, Popover } from "@mui/material";
import { ReactComponent as LinkIconRed } from "components/icons/share-red.svg";
import { ReactComponent as PrivateGifIconRed } from "components/icons/privateGifIconRed.svg";
import { ReactComponent as PublicGifIconRed } from "components/icons/publicGifIconRed.svg";
import { ReactComponent as TrashcanIconRed } from "components/icons/trashcanIconRed.svg";
import { ReactComponent as GalleryIcon } from "components/icons/gallery.svg";
// import nicheIcon from "components/icons/FolderAdd2.svg";
import { IGif } from "services/types";

interface IProps {
  gif: IGif;
  anchorEl: HTMLElement | null;
  onShare: () => void;
  onAddToNiche: () => void;
  onChangeVisibility: () => void;
  onDelete: () => void;
  onClose: () => void;
  onEditGallery?: (gallery?: string) => void;
}

export const GifOptionsDesktop = (props: IProps) => {
  const {
    gif,
    anchorEl,
    onShare,
    onDelete,
    // onAddToNiche,
    onChangeVisibility,
    onClose,
    onEditGallery,
  } = props;

  const svgIconStyles = { "svg": { height: 16, marginRight: "6px", width: 16 } };

  return (
    <Popover
      sx={{
        "& img": { height: "16px", marginRight: "6px" },
      }}
      anchorEl={anchorEl}
      open={true}
      anchorOrigin={{
        vertical: "center",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
      PaperProps={{
        sx: {
          boxShadow: "none"
        }
      }}
      onClose={onClose}
    >
      <List>
        <ListItemButton sx={svgIconStyles} onClick={onShare}>
          <LinkIconRed />
          <p>Share</p>
        </ListItemButton>

        <ListItemButton sx={svgIconStyles} onClick={onChangeVisibility}>
          {gif.published ? <PrivateGifIconRed /> : <PublicGifIconRed />}
          <p>{`Make ${gif.published ? "private" : "public"}`}</p>
        </ListItemButton>

        {
          onEditGallery && gif.gallery && (
            <ListItemButton sx={svgIconStyles} onClick={ () => { onEditGallery(gif.gallery); } }>
              <GalleryIcon />
              <p>Edit Gallery</p>
            </ListItemButton>
          )
        }

        <ListItemButton sx={svgIconStyles} onClick={onDelete}>
          <TrashcanIconRed />
          <p>Delete</p>
        </ListItemButton>
      </List>
    </Popover>
  );
};
